import { Typography } from '@prenuvo/halo-foundation';

import { ActivityLog } from '@/api';
import { FCT } from '@/i18n';

import { ActivityLogUpdate } from './activity-log-update.component';
import { FullObject } from './full-object.component';

export type ActivityLogContentProps = {
  activityLog: ActivityLog;
};

export function ActivityLogContent({ activityLog }: ActivityLogContentProps) {
  const { action, fullObject, objectDiff, relatedObjectType } = activityLog;

  if (action === 'READ' && relatedObjectType === 'Report' && fullObject?.userSession) {
    return (
      <Typography className="mt-2" variant="paragraph-sm">
        {FCT.ACTIVITY_LOGS.USER_ENTRY_MESSAGE}
      </Typography>
    );
  }

  if (action === 'CREATE' && fullObject) {
    return <FullObject action="CREATE" fullObject={fullObject} />;
  }

  if (action === 'UPDATE' && objectDiff) {
    const status = objectDiff.status?.new;

    if (status === 'deprecated') {
      return <FullObject action="DELETE" fullObject={fullObject} />;
    }

    return <ActivityLogUpdate activityLog={activityLog} />;
  }

  return null;
}
